<page-title [title]="'dashboard.internal.pageTitle' | i18next"></page-title>

<iframe
    #iframe
    [src]="frameLink | safe"
    allowfullscreen=""
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    oallowfullscreen="true"
    msallowfullscreen="true"
    [frameBorder]="0"
    width="100%"
    height="100%"
></iframe>
